<script>
  import Calendar from "common/calendar/App";
  import { filters } from "./store";

  export let events = {};

  let url = new URL(window.location.href);

  $: updatedEvents = Object.keys(events).reduce((acc, cur) => {
    let searchParams = url.searchParams;

    if ($filters?.amount) {
      searchParams.set("group_size", $filters.amount);
    } else {
      searchParams.delete("group_size");
    }

    if ($filters?.time) {
      searchParams.set("start_time", $filters.time);
    } else {
      searchParams.delete("start_time");
    }

    let searchParamsString =
      [...searchParams.keys()].length > 0 ? `?${searchParams.toString()}` : "";

    acc[cur] = {
      ...events[cur],
      url: `${events[cur].url}${searchParamsString}`,
    };
    return acc;
  }, {});
</script>

<Calendar events={updatedEvents} {...$$restProps} />
